import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  SET_LOADING_SEND,
  GET_BY_ID_SUCCESS,
  SET_LOADING_SELECTS,
  GET_LIST_FOCUS_SUPPLIER_SUCCESS,
  GET_SELECTS_SUCCESS
} from './focus-supplier-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSend: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    order: 'desc',
    orderBy: 'updatedAt'
  }
};

const focusSupplierReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_SELECTS_SUCCESS: {
      return {
        ...state,
        form: {
          ...state.form,
          selects: action.payload
        }
      };
    }

    case GET_LIST_FOCUS_SUPPLIER_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.rows ?? state?.list?.rows,
          allRows: action.payload?.rows ?? state?.list?.rows,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...state.form,
          data: action.payload
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;

      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.userExternalCode?.toString().startsWith(queryString.toLowerCase()) ||
                item?.userExternalCode?.includes(queryString) ||
                item?.questionaryName?.toString().startsWith(queryString.toLowerCase()) ||
                item?.questionaryName?.includes(queryString)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    default:
      return state;
  }
};

export default focusSupplierReducer;
